/**
 * Error Handler Template Component
 */
import { CardLayout as Card, Divider, Tree } from 'az-platform-ui';

const nodeTemplate = (node, options) => {
    let label = <b style ={ {color: '#fa4545', fontSize: '1rem'}}>{node.label}</b>;
    if (node.error) {
        label = <div> {node.error} </div>;
    }

    return (
        <span className={options.className}>
            {label}
        </span>
    )
}

export const ErrorTemplate = (props) => {
    let { error,  errorInfo } = props;

    const nodes = [
        { key : 0,
            label: 'Error Short Description',
            children: [
                { key : '0-1', error: error.toString()}
            ]

        },
        { key : 1,
            label: 'Error Description',
            children: [
                { key : '1-1', error: errorInfo.componentStack.toString()}
            ]

        }
    ];

    return(
        <Card style ={{width:'100%'}}>
            <h4 style ={ {color: 'red', fontSize: '1.3rem'}}>Something went wrong.</h4>
            <Tree value={nodes} nodeTemplate={nodeTemplate} />
            <Divider />
            <i>For more information, see Console messages</i>
        </Card>
    )
}